<template>
    <a-drawer title="详情" :visible="visible" :wrap-class-name="drawerWrapClassName" destroy-on-close
              :mask-closable="false" @close="onClose" width="55%">
        <div class="ant-drawer-main">
            <a-descriptions bordered :column="1">
                <a-descriptions-item label="政策标题" name="title" :span="2">{{ form.title }}</a-descriptions-item>
                <a-descriptions-item label="政策级别" name="level" :span="2">
                    <dict-render :dict-obj="dictObjs['policy_level']" :text="form.level" v-if="form.level"></dict-render>
                </a-descriptions-item>
                <a-descriptions-item label="政策来源" name="origin">{{form.origin }}</a-descriptions-item>
                <a-descriptions-item label="发布时间" name="publishTime">{{ form.publishTime }}</a-descriptions-item>
                <a-descriptions-item label="发布状态" name="ifPublish">
                    <dict-render :dict-obj="dictObjs['ifPublish']" :text="form.ifPublish" v-if="form.ifPublish"></dict-render>
                </a-descriptions-item>
                <a-descriptions-item label="政策内容" name="content">{{ form.content }}</a-descriptions-item>
            </a-descriptions>
        </div>
    </a-drawer>
</template>
<script>
import {formMixin,dictMixin} from "@/mixins";
import DictRender from "@/components/other/DictRender";

export default {
    name: "index",
    mixins: [formMixin,dictMixin],
    components:{DictRender},
    data() {
        return {
            dictNames:"policy_level,ifPublish",
            form: {
                id: null,
                title: null,
                level: null,
                origin: null,
                publishTime: null,
                ifPublish: null,
            }
        }
    }
}
</script>
